import { apiSlice } from '@/features/api/apiSlice';

export type PlanSlug = 'starter' | 'pro' | 'export-pack';
export type BillingCycle = 'monthly' | 'yearly' | 'once';

export type Subscription = {
  plan: 'free' | 'starter' | 'pro' | 'enterprise';
  trialEndsAt: string | null;
  subscription: {
    id: string;
    provider: string;
    externalId: string;
    status: string;
    currentPeriodStart: string | null;
    currentPeriodEnd: string | null;
    canceledAt: string | null;
  } | null;
};

export type PriceEntry = { amount: number; currency: string; priceId: string };
export type PricingResponse = {
  starter: { monthly: PriceEntry | null; yearly: PriceEntry | null };
  pro: { monthly: PriceEntry | null; yearly: PriceEntry | null };
  exportPack: { once: PriceEntry | null };
  fetchedAt: string;
};

export const billingApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    createCheckoutSession: b.mutation<
      { url: string; sessionId: string },
      { plan: PlanSlug; cycle: BillingCycle }
    >({
      query: (body) => ({ url: '/billing/checkout-session', method: 'POST', body }),
    }),
    getSubscription: b.query<Subscription, void>({
      query: () => '/billing/subscription',
      providesTags: ['Me'],
    }),
    openPortal: b.mutation<{ url: string }, void>({
      query: () => ({ url: '/billing/portal', method: 'POST' }),
    }),
    getPricing: b.query<PricingResponse, void>({
      query: () => '/pricing',
    }),
  }),
});

export const {
  useCreateCheckoutSessionMutation,
  useGetSubscriptionQuery,
  useOpenPortalMutation,
  useGetPricingQuery,
} = billingApi;
